import React from 'react';
import Highcharts from 'highcharts/highstock'

import HighchartsReact from 'highcharts-react-official'
import accessibility from 'highcharts/modules/accessibility';
import moment from 'moment';

accessibility(Highcharts);




const T = {
  bg: '#F6F5F0',
  nav: '#FFFFFF',
  soft: '#F0EEE6',
  line: '#E5E2D8',
  ink: '#232821',
  mut: '#6E766C',
  acc: '#2E9E7A',
};

const CustomHighchart = (props) => {
    const { seriesData } = props

    const options = React.useMemo(() => ({
        chart: {
            type: 'line',
            renderTo: 'container'
        },
        credits: {
            enabled: false
        },

        navigator: {
            enabled: false
        },

        scrollbar: {
            enabled: false,
        },

        exporting: {
            enabled: false
        },

        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
        },

        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false
                },
            }
        },

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 400
                }
            }]
        },

        yAxis: {
            opposite: false,
            title: false,
            tickLength: 0,
            lineWidth: 0,
        },

        xAxis: {
            title: false,
            tickLength: 0,
            lineWidth: 0,
            labels: {
                formatter: function () {
                    return moment(new Date(this.value)).format('MMM yyyy')
                }
            }
        },

        tooltip: {
            pointFormatter: function () {
                return (
                    `<b><span style="color:${this.series.color}">${this.series.name}</span>: </b>
                   ${moment(new Date(this.x)).format('DD MMM yyyy')}
                    ₹${Highcharts.numberFormat(this.y, 2, '.', ',')}`
                )
            }

        },

        rangeSelector: {
            enabled: true,
            allButtonsEnabled: true,
            selected: 4,
            buttonPosition: {
                align: 'left',
            },

            // Range buttons (1m, 3m, 6m, 1y, 5y)
            buttonTheme: {
                fill: 'transparent',
                stroke: 'none',
                'stroke-width': 0,
                r: 8,
                style: {
                    color: T.mut,
                    fontWeight: '600'
                },
                states: {
                    hover: {
                        fill: T.soft,
                        style: {
                            color: T.ink
                        }
                    },
                    select: {
                        fill: T.ink,
                        style: {
                            color: T.bg
                        }
                    }
                }
            },

            // Date input boxes
            inputBoxBorderColor: T.line,
            inputBoxWidth: 120,
            inputBoxHeight: 24,
            inputStyle: {
                color: T.ink,
                fontWeight: '600',
                fontFamily: "'Instrument Sans', system-ui, sans-serif",
                fontSize: '12px',
                outline: 'none'
            },
            labelStyle: {
                color: T.mut,
                fontWeight: '600',
                fontFamily: "'Instrument Sans', system-ui, sans-serif",
            },

            buttons: [{
                type: 'month',
                count: 1,
                text: '1m',
            }, {
                type: 'month',
                count: 3,
                text: '3m',
            }, {
                type: 'month',
                count: 6,
                text: '6m',
            }, {
                type: 'year',
                count: 1,
                text: '1y',
            }, {
                type: 'year',
                count: 5,
                text: '5y',
            }]
        },

        series: seriesData,

    }), [seriesData]);

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
            constructorType={'stockChart'}

        />
    )
}

export default React.memo(CustomHighchart)